export default __webpack_public_path__ + "static/media/brown-shoe.057575fd.jpeg";